import React, {useContext, useEffect, useMemo} from "react";
import {connect} from "react-redux";

import UIPopupContext from "../UIPopupContext";
import ReferralPopupSearchInput from "./ReferralPopupSearchInput";
import {getFabricators} from "../../../Fabricators/FabricatorsActions";
import ReferralPopupContentList from "./ReferralPopupContentList";
import {getDisplayFabricatorName} from "./referralPopupApi";


const ReferralPopupContent = (props) => {

  const {getFabricators} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  const fabricatorsRequest = async (side) => {
    const response = await getFabricators(
      uiPopupContext["fabricatorsPage" + side], 9999, uiPopupContext["fabricatorSearchText" + side]
    );
    uiPopupDispatch({
      fabricatorsListLeft: response.rows || [],
      fabricatorsListRight: [], // we will sort it later, after active fab selection
      responseReceived: true,
    });
  }

  useEffect(() => {
    fabricatorsRequest();
  }, [])

  // console.log("uiPopupContext", uiPopupContext);

  const fabricatorsListLeft = useMemo(() => {
    if (uiPopupContext.fabricatorsListLeft && uiPopupContext.fabricatorSearchTextLeft) {
      const searchText = uiPopupContext.fabricatorSearchTextLeft.toLowerCase().trim();
      return uiPopupContext.fabricatorsListLeft.filter(fabricator => {
        return (getDisplayFabricatorName(fabricator) || "").toLowerCase().includes(searchText);
      })
    }
    return uiPopupContext.fabricatorsListLeft
  }, [uiPopupContext.fabricatorsListLeft, uiPopupContext.fabricatorSearchTextLeft])

  const fabricatorsListRight = useMemo(() => {
    if (uiPopupContext.fabricatorsListRight && uiPopupContext.fabricatorSearchTextRight) {
      const searchText = uiPopupContext.fabricatorSearchTextRight.toLowerCase().trim();
      return uiPopupContext.fabricatorsListRight.filter(fabricator => {
        return (getDisplayFabricatorName(fabricator) || "").toLowerCase().includes(searchText);
      })
    }
    return uiPopupContext.fabricatorsListRight
  }, [uiPopupContext.fabricatorsListRight, uiPopupContext.fabricatorSearchTextRight])

  return (
    <div className="pl-1 pt-1 pr-075 flex-item mr-075">
      <div className="flex h-full">
        <div className="flex-item flex-item--50 flex flex--column pr-1 border-box job-payment__content-left">
          <ReferralPopupSearchInput searchProperty={"fabricatorSearchTextLeft"}/>
          <p className="line--16 font--13 color-gray2 bold mt-0 mb-05 text-left">
            Referrer
          </p>
          <div className="flex-item relative mb-1">
            {!uiPopupContext.responseReceived
              ? <div className="ui-loader ui-loader--medium"/>
              : <ReferralPopupContentList side="left" fabricatorsList={fabricatorsListLeft}/>}
          </div>
        </div>
        <div className="flex-item flex-item--50 flex flex--column pl-15 border-box">
          <ReferralPopupSearchInput searchProperty={"fabricatorSearchTextRight"}/>
          <div className="flex flex--center flex--between line--16 text-left mb-05">
            <div className="flex-item font--13 color-gray2 bold" title="(Disabling wll not delete percentage value)">
              Service Provider
            </div>
            {!uiPopupContext.activeFabricatorId || uiPopupContext.isLoadingReferrals ? null : (
              <div className="flex flex--center text-center pr-15">
                <span className="w-4 generic-popup-textbox-label">Referral</span>
                <span className="w-4 ml-05 generic-popup-textbox-label">Quote</span>
              </div>
            )}
          </div>
          <div className="flex-item relative mb-1">
            {!uiPopupContext.activeFabricatorId
              ? <div className="flex flex--center h-full color-light">Select Referrer</div>
              : uiPopupContext.isLoadingReferrals
                ? <div className="ui-loader ui-loader--medium"/>
                : <ReferralPopupContentList side="right" fabricatorsList={fabricatorsListRight}/>}
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {enabledEntities} = store.customers;

  return {
    page: enabledEntities.data.page,
    totalPages: enabledEntities.data.totalPages,
  };
};

const mapDispatchToProps = {
  getFabricators,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(ReferralPopupContent)
)
